<template>
  <div class="h-navbar-mobile bg-primary-500 text-primary-300 fixed bottom-0 left-0 flex w-full">
    <router-link
      to="/news-feed"
      exact
      exact-active-class="text-white"
      class="grow flex items-center justify-center h-full px-2"
    >
      <i class="text-[22px] mdi mdi-newspaper " />
    </router-link>
    <router-link
      to="/favorites"
      exact
      exact-active-class="text-white"
      class="grow flex items-center justify-center h-full px-2"
    >
      <i class="text-[22px] mdi mdi-star " />
    </router-link>
    <router-link
      to="/goals"
      exact
      exact-active-class="text-white"
      class="grow flex items-center justify-center h-full px-2"
    >
      <i class="text-[22px] mdi mdi-bookmark-check" />
    </router-link>
    <router-link
      v-if="$laravel.user.is_subscribed"
      to="/billing"
      exact
      exact-active-class="text-white"
      class="grow flex items-center justify-center h-full px-2"
    >
      <i class="text-[22px] mdi mdi-cash" />
    </router-link>
    <router-link
      to="/account"
      exact
      exact-active-class="text-white"
      class="grow flex items-center justify-center h-full px-2"
    >
      <i class="text-[22px] mdi mdi-account" />
    </router-link>
  </div>
</template>
<script>
export default {
};
</script>
